"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-explicit-any */
var react_1 = __importStar(require("react"));
var react_2 = require("@fluentui/react");
var clsx_1 = __importDefault(require("clsx"));
var ItemHelper_1 = require("./ItemHelper");
var FilteredHeaderColumn_1 = require("./FilteredHeaderColumn");
require("./CustomDetailList.scss");
var Pagination_1 = __importDefault(require("./Pagination"));
var CustomHeaderColumn_1 = require("./CustomHeaderColumn");
var loadingSpinner_1 = require("../loadingSpinner");
var getFilterFunctions = function (filteredColumns) {
    return filteredColumns.length > 0
        ? function (v) {
            var result = true;
            var _loop_1 = function (filteredColumn) {
                var selfAccess = function (obj) { return obj; };
                var value = filteredColumn.valueAccessor
                    ? filteredColumn.valueAccessor(v)
                    : selfAccess(v);
                result = filteredColumn.criteria.some(function (crit) {
                    var res = true;
                    if (filteredColumn.valueComparator) {
                        if (!filteredColumn.valueComparator(value[crit.fieldName], crit.filterValue)) {
                            res = false;
                        }
                    }
                    else if (value[crit.fieldName] !== crit.filterValue) {
                        res = false;
                    }
                    return res;
                });
                if (result === false) {
                    return "break";
                }
            };
            // eslint-disable-next-line no-restricted-syntax
            for (var _i = 0, filteredColumns_1 = filteredColumns; _i < filteredColumns_1.length; _i++) {
                var filteredColumn = filteredColumns_1[_i];
                var state_1 = _loop_1(filteredColumn);
                if (state_1 === "break")
                    break;
            }
            return result;
        }
        : null;
};
function addFilter(currentFilteredColumns, columns, columnName, criteria) {
    var _a, _b;
    var filteredColumns = __spreadArrays(currentFilteredColumns);
    var existingFilter = filteredColumns.filter(function (c) { return c.columnName === columnName; })[0];
    if (existingFilter) {
        existingFilter.criteria = criteria;
    }
    else {
        var newFilteredColumn = columns.filter(function (c) { return c.name === columnName; })[0];
        filteredColumns.push({
            columnName: columnName,
            fieldName: (_a = newFilteredColumn.fieldName) !== null && _a !== void 0 ? _a : newFilteredColumn.key,
            criteria: criteria,
            valueAccessor: newFilteredColumn.valueAccesor,
            valueComparator: (_b = newFilteredColumn.filterOption) === null || _b === void 0 ? void 0 : _b.comparator,
        });
    }
    return filteredColumns;
}
function removeFilter(currentFilteredColumns, columnName) {
    return currentFilteredColumns.filter(function (c) { return c.columnName !== columnName; });
}
function detailListReducer(state, action) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7;
    var selfAccess = function (obj) { return obj; };
    var selectedColumn;
    var filteredColumns;
    var sortedColumn;
    var itemsSortedAndFiltered;
    var newPageInfo;
    switch (action.type) {
        case 'receivedColumnsDefinition': {
            var cols = __spreadArrays(action.columns);
            if (state.sortedColumnkey) {
                for (var index = 0; index < cols.length; index += 1) {
                    if (cols[index].key === state.sortedColumnkey) {
                        cols[index].isSorted = true;
                        cols[index].isSortedDescending = state.sortedDirection === 'Desc';
                    }
                    else {
                        cols[index].isSortedDescending = undefined;
                        cols[index].isSorted = undefined;
                    }
                }
            }
            return __assign(__assign({}, state), { columns: cols });
        }
        case 'pageSettingChanged':
            if (action.paginationSetting) {
                newPageInfo = ItemHelper_1.BuildPagination((_b = (_a = action.paginationSetting) === null || _a === void 0 ? void 0 : _a.initialPage) !== null && _b !== void 0 ? _b : 0, (_c = state.itemsFiltered) !== null && _c !== void 0 ? _c : state.items, __assign(__assign({}, action.paginationSetting), { nbItemPerPage: (_d = state.nbSelectedItemPerPage) !== null && _d !== void 0 ? _d : (_e = action.paginationSetting) === null || _e === void 0 ? void 0 : _e.nbItemPerPage }));
            }
            else {
                newPageInfo = undefined;
            }
            return __assign(__assign({}, state), { itemsView: ItemHelper_1.pagination((_f = state.itemsFiltered) !== null && _f !== void 0 ? _f : state.items, newPageInfo), pageInfo: newPageInfo });
        case 'itemsPerPageNumberChanged':
            if (action.numberOfItemPerPage !== state.nbSelectedItemPerPage) {
                newPageInfo = ItemHelper_1.BuildPagination(0, (_g = state.itemsFiltered) !== null && _g !== void 0 ? _g : state.items, __assign(__assign({}, state.pageInfo.paginationSetting), { nbItemPerPage: action.numberOfItemPerPage }));
                return __assign(__assign({}, state), { itemsView: ItemHelper_1.pagination((_h = state.itemsFiltered) !== null && _h !== void 0 ? _h : state.items, newPageInfo), pageInfo: newPageInfo, nbSelectedItemPerPage: action.numberOfItemPerPage });
            }
            return __assign({}, state);
        case 'receivedNewItems': {
            var filtersItems = action.payload.items;
            if (action.payload.onReceiveItemsBehavior === 'ResetInternalState') {
                newPageInfo = ItemHelper_1.BuildPagination((_l = (_k = (_j = state.pageInfo) === null || _j === void 0 ? void 0 : _j.paginationSetting) === null || _k === void 0 ? void 0 : _k.initialPage) !== null && _l !== void 0 ? _l : 0, action.payload.items, (_m = state.pageInfo) === null || _m === void 0 ? void 0 : _m.paginationSetting);
            }
            else {
                sortedColumn = state.sortedColumnkey ? state.columns.filter(function (c) { return c.key === state.sortedColumnkey; })[0] : null;
                filtersItems = ItemHelper_1.copyAndSortItems(action.payload.items, getFilterFunctions(state.filteredColumns), (_o = sortedColumn === null || sortedColumn === void 0 ? void 0 : sortedColumn.valueAccesor) !== null && _o !== void 0 ? _o : selfAccess, (_p = sortedColumn === null || sortedColumn === void 0 ? void 0 : sortedColumn.fieldName) !== null && _p !== void 0 ? _p : sortedColumn === null || sortedColumn === void 0 ? void 0 : sortedColumn.key, state.sortedDirection === 'Desc');
                newPageInfo = state.pageInfo
                    ? ItemHelper_1.BuildPagination((_r = (_q = state.pageInfo) === null || _q === void 0 ? void 0 : _q.currentPage) !== null && _r !== void 0 ? _r : ((_u = (_t = (_s = state.pageInfo) === null || _s === void 0 ? void 0 : _s.paginationSetting) === null || _t === void 0 ? void 0 : _t.initialPage) !== null && _u !== void 0 ? _u : 0), filtersItems, (_v = state.pageInfo) === null || _v === void 0 ? void 0 : _v.paginationSetting)
                    : undefined;
            }
            return __assign(__assign({}, state), { items: action.payload.items, itemsFiltered: filtersItems, itemsView: ItemHelper_1.pagination(filtersItems, newPageInfo), pageInfo: newPageInfo });
        }
        case 'Addfilter':
            if (!state.items)
                return state;
            filteredColumns = addFilter(state.filteredColumns, state.columns, action.columnName, action.criteria);
            sortedColumn = state.sortedColumnkey
                ? state.columns.filter(function (c) { return c.key === state.sortedColumnkey; })[0]
                : null;
            itemsSortedAndFiltered = ItemHelper_1.copyAndSortItems(state.items, getFilterFunctions(filteredColumns), (_w = sortedColumn === null || sortedColumn === void 0 ? void 0 : sortedColumn.valueAccesor) !== null && _w !== void 0 ? _w : selfAccess, (_x = sortedColumn === null || sortedColumn === void 0 ? void 0 : sortedColumn.fieldName) !== null && _x !== void 0 ? _x : sortedColumn === null || sortedColumn === void 0 ? void 0 : sortedColumn.key, state.sortedDirection === 'Desc');
            newPageInfo = state.pageInfo
                ? ItemHelper_1.BuildPagination((_y = state.pageInfo) === null || _y === void 0 ? void 0 : _y.currentPage, itemsSortedAndFiltered, (_z = state.pageInfo) === null || _z === void 0 ? void 0 : _z.paginationSetting)
                : undefined;
            return __assign(__assign({}, state), { filteredColumns: filteredColumns, itemsFiltered: itemsSortedAndFiltered, itemsView: ItemHelper_1.pagination(itemsSortedAndFiltered, newPageInfo), pageInfo: newPageInfo });
        case 'Removefilter':
            if (!state.items)
                return state;
            filteredColumns = removeFilter(state.filteredColumns, action.columnName);
            sortedColumn = state.sortedColumnkey
                ? state.columns.filter(function (c) { return c.name === state.sortedColumnkey; })[0]
                : null;
            itemsSortedAndFiltered = ItemHelper_1.copyAndSortItems(state.items, getFilterFunctions(filteredColumns), (_0 = sortedColumn === null || sortedColumn === void 0 ? void 0 : sortedColumn.valueAccesor) !== null && _0 !== void 0 ? _0 : selfAccess, (_1 = sortedColumn === null || sortedColumn === void 0 ? void 0 : sortedColumn.fieldName) !== null && _1 !== void 0 ? _1 : sortedColumn === null || sortedColumn === void 0 ? void 0 : sortedColumn.key, state.sortedDirection === 'Desc');
            newPageInfo = state.pageInfo
                ? ItemHelper_1.BuildPagination((_2 = state.pageInfo) === null || _2 === void 0 ? void 0 : _2.currentPage, itemsSortedAndFiltered, (_3 = state.pageInfo) === null || _3 === void 0 ? void 0 : _3.paginationSetting)
                : undefined;
            return __assign(__assign({}, state), { filteredColumns: filteredColumns, itemsFiltered: itemsSortedAndFiltered, itemsView: ItemHelper_1.pagination(itemsSortedAndFiltered, newPageInfo), pageInfo: newPageInfo });
        case 'sortAsc':
            if (!state.items)
                return state;
            selectedColumn = state.columns.filter(function (c) { return c.name === action.columnName; })[0];
            itemsSortedAndFiltered = ItemHelper_1.copyAndSortItems(state.items, getFilterFunctions(state.filteredColumns), (_4 = selectedColumn.valueAccesor) !== null && _4 !== void 0 ? _4 : selfAccess, (_5 = selectedColumn === null || selectedColumn === void 0 ? void 0 : selectedColumn.fieldName) !== null && _5 !== void 0 ? _5 : selectedColumn === null || selectedColumn === void 0 ? void 0 : selectedColumn.key, false);
            return __assign(__assign({}, state), { columns: state.columns.map(function (c) { return (__assign(__assign({}, c), { isSortedDescending: c.name === action.columnName, isSorted: c.name === action.columnName })); }), sortedColumnName: selectedColumn.name, sortedColumnkey: selectedColumn.key, sortedDirection: 'Asc', itemsFiltered: itemsSortedAndFiltered, itemsView: ItemHelper_1.pagination(itemsSortedAndFiltered, state.pageInfo) });
        case 'sortDesc':
            if (!state.items)
                return state;
            selectedColumn = state.columns.filter(function (c) { return c.name === action.columnName; })[0];
            itemsSortedAndFiltered = ItemHelper_1.copyAndSortItems(state.items, getFilterFunctions(state.filteredColumns), (_6 = selectedColumn.valueAccesor) !== null && _6 !== void 0 ? _6 : selfAccess, (_7 = selectedColumn === null || selectedColumn === void 0 ? void 0 : selectedColumn.fieldName) !== null && _7 !== void 0 ? _7 : selectedColumn === null || selectedColumn === void 0 ? void 0 : selectedColumn.key, true);
            return __assign(__assign({}, state), { columns: state.columns.map(function (c) { return (__assign(__assign({}, c), { isSortedDescending: c.name !== action.columnName, isSorted: c.name === action.columnName })); }), sortedColumnName: selectedColumn.name, sortedColumnkey: selectedColumn.key, sortedDirection: 'Desc', itemsFiltered: itemsSortedAndFiltered, itemsView: ItemHelper_1.pagination(itemsSortedAndFiltered, state.pageInfo) });
        case 'resetFilters':
            return __assign(__assign({}, state), { filteredColumns: [] });
        case 'beginNav':
        case 'endNav':
        case 'pageNav':
            if (state.pageInfo) {
                switch (action.type) {
                    case 'beginNav':
                        newPageInfo = __assign(__assign({}, state.pageInfo), { currentPage: 0 });
                        break;
                    case 'endNav':
                        newPageInfo = __assign(__assign({}, state.pageInfo), { currentPage: state.pageInfo.totalPage - 1 });
                        break;
                    case 'pageNav':
                        newPageInfo = __assign(__assign({}, state.pageInfo), { currentPage: action.pageNumber });
                        break;
                    default:
                        throw new Error('navigation page action invalid');
                }
                return __assign(__assign({}, state), { itemsView: ItemHelper_1.pagination(state.itemsFiltered, newPageInfo), pageInfo: newPageInfo });
            }
            return __assign(__assign({}, state), { itemsView: ItemHelper_1.pagination(state.itemsFiltered) });
        default:
            return __assign({}, state);
    }
}
function getSortedColumnInfo(state) {
    var _a, _b;
    if (state.sortedColumnName && state.sortedColumnkey) {
        var col = state.columns.filter(function (c) { return c.key === state.sortedColumnkey; });
        return {
            name: state.sortedColumnName,
            key: state.sortedColumnkey,
            isSortDesc: (col && col.length === 1) ? ((_b = (_a = col[0]) === null || _a === void 0 ? void 0 : _a.isSortedDescending) !== null && _b !== void 0 ? _b : false) : false,
        };
    }
    return undefined;
}
var CustomDetailList = function (props) {
    var _a, _b, _c;
    var paginationSetting = props.paginationSetting, items = props.items, totalItemCount = props.totalItemCount, columns = props.columns, onChanged = props.onChanged, onFilterChanged = props.onFilterChanged, noItemsPlaceholder = props.noItemsPlaceholder, className = props.className, layoutMode = props.layoutMode, onPageChanged = props.onPageChanged, onSortChanged = props.onSortChanged, onNbItemPerPageChanged = props.onNbItemPerPageChanged, selectionMode = props.selectionMode, selection = props.selection, onRenderDetailsFooter = props.onRenderDetailsFooter, labels = props.labels, forceResetFilter = props.forceResetFilter, onRowClick = props.onRowClick, enableShimmer = props.enableShimmer, shimmerLines = props.shimmerLines, setKey = props.setKey, selectionPreservedOnEmptyClick = props.selectionPreservedOnEmptyClick, onReceiveItemsBehavior = props.onReceiveItemsBehavior, loadingMessage = props.loadingMessage;
    var _d = react_1.useReducer(detailListReducer, {
        columns: [],
        filteredColumns: [],
    }, function () {
        var pageInfo = ItemHelper_1.BuildPagination(0, items, paginationSetting);
        return {
            columns: columns,
            items: items,
            itemsView: ItemHelper_1.pagination(items, pageInfo),
            pageInfo: pageInfo,
            filteredColumns: [],
        };
    }), state = _d[0], dispatch = _d[1];
    var pageInfo = (paginationSetting === null || paginationSetting === void 0 ? void 0 : paginationSetting.currentPage) != null &&
        (paginationSetting === null || paginationSetting === void 0 ? void 0 : paginationSetting.totalPage) != null
        ? __assign(__assign({}, state.pageInfo), { currentPage: paginationSetting.currentPage, totalPage: paginationSetting.totalPage, paginationSetting: state.pageInfo
                ? state.pageInfo.paginationSetting
                : paginationSetting }) : state.pageInfo;
    var currentPage = paginationSetting === null || paginationSetting === void 0 ? void 0 : paginationSetting.currentPage;
    var totalPage = paginationSetting === null || paginationSetting === void 0 ? void 0 : paginationSetting.totalPage;
    react_1.useEffect(function () {
        if (state.pageInfo && paginationSetting) {
            if (state.pageInfo.paginationSetting.nbPageShown === paginationSetting.nbPageShown &&
                state.pageInfo.paginationSetting.nbItemPerPage === paginationSetting.nbItemPerPage &&
                paginationSetting.totalPage === undefined && paginationSetting.currentPage === undefined) {
                // if pagination is not manage externaly and nothing change except paginationSetting.initialPage then do not dispatch action
                return;
            }
        }
        dispatch({ type: 'pageSettingChanged', paginationSetting: paginationSetting });
    }, [paginationSetting, currentPage, totalPage]);
    react_1.useEffect(function () {
        if (items) {
            dispatch({ type: 'receivedNewItems', payload: { items: items, onReceiveItemsBehavior: onReceiveItemsBehavior !== null && onReceiveItemsBehavior !== void 0 ? onReceiveItemsBehavior : 'ResetInternalState' } });
        }
    }, [items, onReceiveItemsBehavior]);
    react_1.useEffect(function () {
        var _a, _b;
        var handle = false;
        if (onFilterChanged) {
            handle = onFilterChanged([]);
        }
        if (onChanged) {
            handle = onChanged((_b = (_a = state.pageInfo) === null || _a === void 0 ? void 0 : _a.currentPage) !== null && _b !== void 0 ? _b : 0, [], getSortedColumnInfo(state));
        }
        if (!handle) {
            dispatch({ type: 'resetFilters' });
        }
    }, [forceResetFilter]);
    react_1.useEffect(function () {
        dispatch({ type: 'receivedColumnsDefinition', columns: columns });
    }, [columns]);
    var onHeaderColumnClick = function (pageIndex, ev, col) {
        if (col) {
            var handled = false;
            if (!col.allowSorting)
                return;
            var isSortingDesc = col.isSortedDescending === undefined ? true : col.isSortedDescending;
            var sortedColumn = {
                name: col.name,
                key: col.key,
                isSortDesc: !isSortingDesc,
            };
            if (onSortChanged) {
                handled = onSortChanged(sortedColumn);
            }
            if (onChanged) {
                handled = onChanged(pageIndex, state.filteredColumns, sortedColumn);
            }
            if (!handled) {
                dispatch({
                    type: sortedColumn.isSortDesc ? 'sortDesc' : 'sortAsc',
                    columnName: sortedColumn.name,
                });
            }
        }
    };
    var onHeaderFilterApply = function (pageIndex, col, criteria) {
        var _a, _b;
        var handled = false;
        if (criteria === null || criteria === void 0 ? void 0 : criteria.some(function (v) { return !!v.filterValue; })) {
            var newFilters = addFilter(state.filteredColumns, state.columns, col.name, criteria);
            if (onFilterChanged) {
                handled = onFilterChanged(newFilters);
            }
            if (onChanged) {
                handled = onChanged((_b = (_a = state.pageInfo) === null || _a === void 0 ? void 0 : _a.currentPage) !== null && _b !== void 0 ? _b : 0, newFilters, getSortedColumnInfo(state));
            }
            if (!handled) {
                dispatch({
                    type: 'Addfilter',
                    columnName: col.name,
                    criteria: criteria,
                });
            }
        }
        else {
            var filters = removeFilter(state.filteredColumns, col.name);
            if (onFilterChanged) {
                handled = onFilterChanged(filters);
            }
            if (onChanged) {
                handled = onChanged(pageIndex, filters, getSortedColumnInfo(state));
            }
            if (!handled) {
                dispatch({
                    type: 'Removefilter',
                    columnName: col.name,
                });
            }
        }
    };
    var onNavigate = function (action) {
        var handled = false;
        var pageIndex = 0;
        switch (action.type) {
            case 'pageNav':
                pageIndex = action.pageNumber;
                break;
            case 'beginNav':
                pageIndex = 0;
                break;
            case 'endNav':
                pageIndex = (pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.totalPage) ? (pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.totalPage) - 1 : 0;
                break;
            case 'itemsPerPageNumberChanged':
                if (onNbItemPerPageChanged) {
                    if (onNbItemPerPageChanged(action.numberOfItemPerPage)) {
                        return;
                    }
                }
                break;
            default:
                break;
        }
        if (onPageChanged) {
            handled = onPageChanged(pageIndex);
        }
        if (onChanged) {
            handled = onChanged(pageIndex, state.filteredColumns, getSortedColumnInfo(state));
        }
        if (!handled) {
            dispatch(action);
        }
    };
    var onRenderRow = function (detailsRowProps) {
        if (detailsRowProps) {
            return (react_1.default.createElement("div", { "aria-hidden": true, onClick: function () {
                    if (onRowClick) {
                        onRowClick(detailsRowProps.item);
                    }
                } },
                react_1.default.createElement(react_2.DetailsRow, __assign({}, detailsRowProps))));
        }
        return (null);
    };
    return (react_1.default.createElement("div", { className: clsx_1.default('eta-detailListWrapper', loadingMessage ? 'readonly' : '') },
        react_1.default.createElement(react_2.ShimmeredDetailsList, { className: className, items: (_a = state.itemsView) !== null && _a !== void 0 ? _a : [], columns: state.columns, selectionMode: selectionMode, layoutMode: layoutMode, setKey: setKey, selectionPreservedOnEmptyClick: selectionPreservedOnEmptyClick, selection: selection, shimmerLines: shimmerLines, enableShimmer: enableShimmer, onRenderRow: onRenderRow, onColumnHeaderClick: function (ev, colInfo) { var _a; return onHeaderColumnClick((_a = pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.currentPage) !== null && _a !== void 0 ? _a : 0, ev, colInfo); }, onRenderDetailsFooter: onRenderDetailsFooter, onRenderDetailsHeader: function (headerProps, defaultRender) {
                if (defaultRender && headerProps) {
                    return defaultRender(__assign(__assign({}, headerProps), { 
                        // eslint-disable-next-line react/display-name
                        onRenderColumnHeaderTooltip: function (tooltipHostProps, df) {
                            if (tooltipHostProps === null || tooltipHostProps === void 0 ? void 0 : tooltipHostProps.column) {
                                var columnInfo = tooltipHostProps.column;
                                if (columnInfo === null || columnInfo === void 0 ? void 0 : columnInfo.filterOption) {
                                    // eslint-disable-next-line react/prop-types
                                    return (react_1.default.createElement(FilteredHeaderColumn_1.FilteredHeaderColumn, { column: columnInfo, filter: columnInfo.filterOption, onColumnClick: function (ev, colInfo) { var _a; return onHeaderColumnClick((_a = pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.currentPage) !== null && _a !== void 0 ? _a : 0, ev, colInfo); }, onfilterApply: function (col, criteria) { var _a; return onHeaderFilterApply((_a = pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.currentPage) !== null && _a !== void 0 ? _a : 0, col, criteria); }, forceResetFilter: forceResetFilter }));
                                }
                                if (columnInfo.nameAsJsx) {
                                    return (react_1.default.createElement(CustomHeaderColumn_1.CustomHeaderColumn, { column: columnInfo, onColumnClick: function (ev, colInfo) { var _a; return onHeaderColumnClick((_a = pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.currentPage) !== null && _a !== void 0 ? _a : 0, ev, colInfo); } }));
                                }
                            }
                            if (df) {
                                return df(tooltipHostProps);
                            }
                            return react_1.default.createElement(react_1.default.Fragment, null);
                        } }));
                }
                return react_1.default.createElement(react_1.default.Fragment, null);
            } }),
        react_1.default.createElement("div", { className: "eta-detailList" },
            !enableShimmer && state.itemsView && state.itemsView.length === 0 && (react_1.default.createElement("div", { className: "centerFlex" }, noItemsPlaceholder)),
            react_1.default.createElement(react_1.default.Fragment, null, pageInfo &&
                state.itemsView &&
                state.itemsView.length > 0 &&
                pageInfo.totalPage > 0 && (react_1.default.createElement(Pagination_1.default, { itemsPerPage: pageInfo.paginationSetting.nbItemPerPage, currentPageIndex: pageInfo.currentPage, totalPageCount: pageInfo.totalPage, labels: {
                    resultPerPage: labels.resultPerPage,
                    totalRecord: labels.totalRecord,
                }, totalRecordCount: (_c = totalItemCount !== null && totalItemCount !== void 0 ? totalItemCount : (_b = state.itemsView) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : undefined, nbPagesShown: pageInfo.paginationSetting.nbPageShown, onNavigate: onNavigate })))),
        (loadingMessage && !enableShimmer) && (react_1.default.createElement("div", { className: 'eta-gridLoadingPanel' },
            react_1.default.createElement("div", { className: 'eta-gridLoadingItem' },
                react_1.default.createElement(loadingSpinner_1.LoadingSpinner, { messageLabel: loadingMessage }))))));
};
exports.default = CustomDetailList;
//# sourceMappingURL=CustomDetailList.js.map